import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Cedar from '~/images/logos/cedar.svg';
import Fetch from '~/images/logos/fetch.svg';
import Gopuff from '~/images/logos/gopuff.svg';
import MGM from '~/images/logos/mgm.svg';
import Shake from '~/images/logos/shake.svg';
import Shipt from '~/images/logos/shipt.svg';
import Slice from '~/images/logos/slice.svg';
import Uber from '~/images/logos/uber.svg';
import Wallmart from '~/images/logos/wallmart.svg';

const partners = [
  { src: Uber, alt: 'Uber Eats logo' },
  { src: MGM, alt: 'MGM logo' },
  { src: Wallmart, alt: 'Wallmart logo' },
  { src: Slice, alt: 'Slice logo' },
  { src: Fetch, alt: 'Fetch logo' },
  { src: Cedar, alt: 'Cedars Sinai logo' },
  { src: Shake, alt: 'Shake Shack logo' },
  { src: Shipt, alt: 'Shipt logo' },
  { src: Gopuff, alt: 'Gopuff logo' },
];

export default function TrustPartners() {
  return (
    <Container sx={{ py: 10 }}>
      <Stack alignItems="center">
        <Typography variant="h6" mb={6} textAlign="center" width={{ xs: '100%', sm: '60%', md: '40%' }}>
          Companies That Trust Us!
        </Typography>
      </Stack>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        gap={6}
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
      >
        {partners.map((p) => (
          <img key={p.src} src={p.src} alt={p.alt} />
        ))}
      </Stack>
    </Container>
  );
}
